import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { CheckGroupPermissions } from "@helpers/checkGroupPermissions";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Client } from "@interfaces/models/client.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { SalesOrder } from "@interfaces/salesOrder.interface";
import { User } from "@interfaces/user.interface";
import { AppSettingsService } from "@services/appSettings.service";
import { ClientService } from "@services/client.service";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { SalesOrderService } from "@services/salesOrder.service";
import { SalesOrderPartService } from "@services/salesOrderPart.service";
import { UserService } from "@services/user.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "salesOrders",
	styleUrls: ["salesOrders.css"],
	templateUrl: "salesOrders.html"
})
export class SalesOrdersAdminComponent {
	canExportGrid = false;
	clients: Client[] = [];
	deleteEnabled = true;
	editEnabled = true;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	isExecutive = false;
	itemType = "Sales Order"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: SalesOrder[] = [];
	staff: User[] = [];
	title: string;

	constructor(private appSettingsService: AppSettingsService, private toastService: ToastService, private router: Router, private exportLogService: ExportLogService, private itemService: SalesOrderService, private clientService: ClientService, private protectedGridService: ProtectedGridService, private salesOrderPartService: SalesOrderPartService, private userService: UserService) {
		this.title = "Sales Orders";
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getClients();
		this.getStaff();
		this.getItems();

		this.headerPrimaryButtons = [{ method: "viewOutstanding", text: "Outstanding" }];

		this.isExecutive = CheckGroupPermissions(appSettingsService, "Executive");

		if (this.isExecutive) {
			this.headerPrimaryButtons.push({ icon: "fal fa-download", method: "generateAndDownloadIncompleteSalesOrderPartsReportPDF", text: "Incomplete Sales Order Parts Report" });
		}
		this.checkGridExportPermissions();
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Sales Orders")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this item?");
		if (result) {
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => {
						this.toastService.success(this.itemType + " deleted!");
						this.getItems();
					},
					(err: any) => {
						console.log(err);
						this.toastService.error(err?.error?.error || "Something Went Wrong!");
					},
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}_edit`]);
	}

	generateAndDownloadIncompleteSalesOrderPartsReportPDF() {        
		this.salesOrderPartService.generateAndDownloadIncompleteSalesOrderPartReportPdf().subscribe(
			(response: any) =>{
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
				downloadLink.setAttribute("download", "Incomplete Sales Order Parts Report.pdf");
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
	}

	getClients() {
		this.clientService.getAll()
			.subscribe(
				(res: any) => {
					this.clients = res.response.items;
				},
				(err) => console.log(err)
			);
	}

	getDisplayExpr(item: User) {
		if (!item) {
			return "";
		}

		return `${item.firstName} ${item.lastName}`;
	}


	getItems() {
		this.gridLoading = true;
		this.itemService.getGrid()
			.subscribe(
				(res: any) => {
					this.items = res.response;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getStaff() {
		this.userService.getAll()
			.subscribe(
				(res: any) => this.staff = res.response.items,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Sales Orders";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewOutstanding() {
		this.router.navigate(["admin/outstandingOrders"]);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}`]);
	}
}